import React from 'react';

// La liste OneTrust de cookies
const CookieList = () => {
  return <div id="optanon-cookie-policy"></div>;
};

export default CookieList;
